import { GOOGLE_ANALYTICS_MEASUREMENT_ID } from "./src/components/cookieConsent";

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("config", GOOGLE_ANALYTICS_MEASUREMENT_ID, {
    anonymize_ip: true,
    page_path: `${location.pathname}${location.search}${location.hash}`,
  });
};
